export const status = [
  { id: 'stopped', name: 'STOPPED' },
  { id: 'running', name: 'RUNNING' },
];